interface ArrowLeftProps {
  size?: number;
}

function ArrowLeft({ size = 29 }: ArrowLeftProps) {
  return (
    <svg
      // width="17"
      height={size}
      viewBox="0 0 17 29"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 26.4076L14.4216 29L0 14.5L14.4216 0L17 2.59242L5.15681 14.5L17 26.4076Z" />
    </svg>
  );
}

export default ArrowLeft;
